import alioss from 'ali-oss'
import React, { useEffect, useRef, useState } from "react"
import { Button, Empty, Menu, MenuProps, message as messager } from "antd"

import FullModal from "../../../../full-modal"
import Control from "../../../../crf_form/control/Control"

import { getVisitTree } from "../../../../../services/data/data"
import { GetFormDataById } from "../../../../../services/dct/DctService"

import modStyl from './index.module.scss'
import { batchCopy } from '../../../../../services/file'
import { saveFormData } from '../../../../../services/data/DataService'
import { dealValidationRulesGroup, deleteFormData, filterNoVaildData } from '../../../../crf_form/helper'
import verify, { replaceFieldRule } from '../../../../crf_form/utils/verify'
import formAction from '../../../../crf_form/utils/formAction'

interface PasteModalProps {
  subjectCode: string
  // 要粘贴的字段
  pasteFieldValue: string[]
  onClose(): void
}

const PasteModal: React.FC<PasteModalProps> = ({ subjectCode, pasteFieldValue, onClose })=> {

  const [loading, setLoading] = useState(false)
  const [formId, setFormId] = useState(0)
  const [formSet, setFormSet] = useState<any>()

  const [items, setItems] = useState<MenuProps['items']>([])

  const formControlRef = useRef<any>(null);

  // 获取表单数据
  const fetchForm = async (id: number) => {
    const {code, data} = await GetFormDataById({
      id,
    })

    if(code === 0) {
      data.dataActions = [
        "DataActionInput",
        "DataActionSourcePaste",
      ]
      setFormSet(data)
    }
  }
  
  const fetchMenu = async()=> {
    const { data } = await getVisitTree(subjectCode)

    const pieces:MenuProps['items'] = []

    // 转换
    data.forEach((t)=> {
      pieces.push({
        key: t.visitId,
        label: t.visitName,
        children: t.formNames.map(({formId, formName})=> ({key: formId, label: formName}))
      })
    })

    setItems(pieces)
  }

  const refreshData = async()=> {
    fetchForm(formId)
  }

  const handleClick: MenuProps['onClick'] = ({ key })=> {
    setFormId(Number(key))
    fetchForm(Number(key))
  }

  const handlePaste = async(dataCode: string)=> {

    const hide = messager.loading('正在处理...')

    const { code, message, data } = await batchCopy(pasteFieldValue)

    hide()
    if (code !== 0) {
      messager.error(message)
      return
    }

    const item = formSet.values.find((t: any)=> t.dataCode === dataCode)

    const value = [...data]
    if (item && Array.isArray(item.value)) {
      value.unshift(...item.value)
    }

    const [deCode] = dataCode.split('#')

    // 执行保存表单
    formAction.saveData({
        formId: formId,
        submit: false,
        values: [
          {
            dataCode,
            deCode,
            value
          }
        ]
    });

    setTimeout(()=>{
      formControlRef.current?.updateValues();
      messager.success('粘贴成功')
    }, 500)
  }


  //当提交时
  const onSubmit = async() => {
    if (formControlRef.current) {
      const {body, ...params} = formControlRef.current.getSavedForm();
      // 提交时进行校验
      let validationRules: any = [];
      body.forEach((element: any) => {
        validationRules.push(element.children);
        // todo children可能有多层
      });
      
      // 铺平
      let validationRulesAll: any = [];
      validationRules.forEach((outVal: any) => {
          outVal.forEach((inVal: any) => {
              validationRulesAll.push(inVal);
          });
      });

      validationRulesAll = dealValidationRulesGroup(validationRulesAll);

      //过滤到不需要校验的数据，一些不显示的数据二级数据
      validationRulesAll = filterNoVaildData(validationRulesAll, params.values);

      // feature: 处理number字段和number字段数值比较
      validationRulesAll.forEach(({ validationRules }: any)=> {
        replaceFieldRule(validationRules, params.values)
      })

      const notValid = validationRulesAll.some((val: any) => {
        // 匹配的数据
        let value = (params.values.find((v: any) => v.dataCode == val.dataCode));
        if (!value) {
          return;
        }

        let judge = verify.checkValueByRange(value.value, val);
        let judge1 = verify.checkValueByRep(value.value, val);
        if (!judge || !judge1) {
          if (!judge1) {
            messager.error('请输入正确的格式！', 1)
          }
          return true;
        }
        let isEmpty = verify.isEmpty(value.value, val);
        if (isEmpty) {
          messager.error(val.label + '需填写或选择完整', 1);
          return true;
        }
      })

      if (notValid) {
        return;
      }

      setLoading(true)
      
      const {code} = await saveFormData(params)

      setLoading(false)

      if (code === 0) {
        deleteFormData(formId)
        messager.success('表单提交成功')
      }
    }
  }

  useEffect(()=> {
    fetchMenu()
  }, [])

  return (
    <FullModal onClose={onClose} title="粘贴数据">
      <div className={modStyl.wrapper}>
        <div className={modStyl.west}>
          <Menu onClick={handleClick} items={items}/>
        </div>
        <div className={modStyl.east}>
          {
            formId > 0 && (
              <div className={modStyl.main}>
                <Control controlId="paste" onCopyField={()=> {}} onPasteField={handlePaste} style={{'--retention': '100px'}} checkSource="paste" updateSelfData={refreshData} formId={formId} data={formSet} ref={formControlRef}/>
                <div className={modStyl.footer}>
                  <Button loading={loading} onClick={onSubmit} type="primary">提交</Button>
                </div>
              </div>
            )
          }
          {
            formId === 0 && (
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )
          }
        </div>
      </div>
    </FullModal>
  )
}

export default PasteModal